import React from 'react';

const GalleryConsumenIcon = ({ width = 20, height = 20, fill = '#CE181E' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.8926 10.9417C15.0342 11.7167 15.8342 12.7667 15.8342 14.1667V16.6666H18.3342C18.7926 16.6666 19.1676 16.2916 19.1676 15.8333V14.1667C19.1676 12.35 16.1926 11.275 13.8926 10.9417Z"
        fill={fill}
      />
      <path
        d="M7.49935 10C9.3403 10 10.8327 8.50766 10.8327 6.66671C10.8327 4.82576 9.3403 3.33337 7.49935 3.33337C5.6584 3.33337 4.16602 4.82576 4.16602 6.66671C4.16602 8.50766 5.6584 10 7.49935 10Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5009 10C14.3426 10 15.8342 8.50837 15.8342 6.66671C15.8342 4.82504 14.3426 3.33337 12.5009 3.33337C12.1092 3.33337 11.7426 3.41671 11.3926 3.53337C12.0842 4.39171 12.5009 5.48337 12.5009 6.66671C12.5009 7.85004 12.0842 8.94171 11.3926 9.80004C11.7426 9.91671 12.1092 10 12.5009 10Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.50065 10.8334C5.27565 10.8334 0.833984 11.95 0.833984 14.1667V15.8334C0.833984 16.2917 1.20898 16.6667 1.66732 16.6667H13.334C13.7923 16.6667 14.1673 16.2917 14.1673 15.8334V14.1667C14.1673 11.95 9.72565 10.8334 7.50065 10.8334Z"
        fill={fill}
      />
    </svg>
  );
};

export default GalleryConsumenIcon;
